import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=dbc7fe20&scoped=true&"
import script from "./deal.vue?vue&type=script&lang=js&"
export * from "./deal.vue?vue&type=script&lang=js&"
import style0 from "./deal.vue?vue&type=style&index=0&id=dbc7fe20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc7fe20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wd\\fin24\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbc7fe20')) {
      api.createRecord('dbc7fe20', component.options)
    } else {
      api.reload('dbc7fe20', component.options)
    }
    module.hot.accept("./deal.vue?vue&type=template&id=dbc7fe20&scoped=true&", function () {
      api.rerender('dbc7fe20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/deal.vue"
export default component.exports